module.exports = __webpack_public_path__ + "static/media/instagram.c9b542c9.svg";